let language = {

    QUILL_KEYBOARD_SHORTCUTS_MODAL_TITLE: "keyboard Shortcuts",
    QUILL_KEYBOARD_SHORTCUTS_MODAL_DEFAULT_SHORTCUTS_TITLE:"Default shortcuts, Ctrl + letter:",
    QUILL_KEYBOARD_SHORTCUTS_MODAL_DEFAULT_SHORTCUTS_HEAD_LATTER:"Letter",
    QUILL_KEYBOARD_SHORTCUTS_MODAL_DEFAULT_SHORTCUTS_HEAD_ACTION:"Action",
    QUILL_KEYBOARD_SHORTCUTS_UNDERLINE:"Underline",
    QUILL_KEYBOARD_SHORTCUTS_ITALIC:"Italic",
    QUILL_KEYBOARD_SHORTCUTS_COPY:"Copy",
    QUILL_KEYBOARD_SHORTCUTS_SELECT_ALL:"Select all",
    QUILL_KEYBOARD_SHORTCUTS_REDO:'Redo',
    QUILL_KEYBOARD_SHORTCUTS_BOLD:"Bold",
    QUILL_KEYBOARD_SHORTCUTS_CUT:"Cut",
    QUILL_KEYBOARD_SHORTCUTS_PASTE:"Paste",
    QUILL_KEYBOARD_SHORTCUTS_UNDO:"Undo",
    QUILL_KEYBOARD_SHORTCUTS_UNDO_INSERT:"Insert/edit link",


};


export { language }